import { atomWithStorage } from 'jotai/utils';

import { createSsrSafeStorage } from './ssrSafeStorage';

/** localStorage key — cleared on logout (`clearLogoutStorage`). */
export const ROUTINES_EXPLORE_BANNER_DISMISSED_STORAGE_KEY =
  'heidi.routinesExploreBannerDismissed';

/**
 * Whether the user has dismissed the "What's a routine?" banner at the top of
 * the routines Explore feed. Persists across reloads so the education surface
 * doesn't re-nag on every visit; cleared on full logout so the next account on
 * this device gets its own introduction.
 */
export const routinesExploreBannerDismissedAtom = atomWithStorage<boolean>(
  ROUTINES_EXPLORE_BANNER_DISMISSED_STORAGE_KEY,
  false,
  createSsrSafeStorage<boolean>()
);
